var styles = {"DropArea":"styles-module_DropArea__ctYFQ","PlusIcon":"styles-module_PlusIcon__-rWvM","Container":"styles-module_Container__COj80","Disabled":"styles-module_Disabled__V-Nun"};

export { styles as default };
